import { createRoot } from 'react-dom/client';
import React, { StrictMode } from 'react';
// import ReactDOM from 'react-dom';
import App from './App';
import Main from './Main';
import { ThemeProvider } from './context/ThemeContext';
import ErrorBoundary from './components/common/ErrorBoundary';
import './helpers/initFA';

const rootElement = document.getElementById('main');
const root = createRoot(rootElement);

root.render(
  <StrictMode>
    <ErrorBoundary>
      <ThemeProvider>
        <Main>
          <App />
        </Main>
      </ThemeProvider>
    </ErrorBoundary>
  </StrictMode>
);
